import {
  InsertSaleInvoiceRequest,
  InsertSaleInvoiceResponse,
  GetSaleInvoiceListResponse,
} from '@/model/saleInvoiceModel';
import { ResultModel } from '@/model/viewModel';
import { post } from '@/utils/api';

export const insertSaleInvoice = (data: InsertSaleInvoiceRequest) =>
  post<InsertSaleInvoiceResponse>('/sale/invoice/insert', data);

export const getSaleInvoiceList = (data: any) =>
  post<ResultModel<GetSaleInvoiceListResponse>>('/sale/invoice/select', data);
